module.exports = __webpack_public_path__ + "static/media/history.f14ad701.svg";